export default {
    methods: {
        randomNumberBetween(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        toLocaleString(number) {
            if (!number) return 0;
            
            return number.toLocaleString();
        }
    }
};
